<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">utilities</p>
        <h1 class="dg-header">Flex</h1>
        <p>Quickly manage the layout, alignment, and sizing of grid columns, navigation, components, and more with a full suite of responsive flexbox utilities. For more complex implementations, custom CSS may be necessary.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <!-- Content -->
        <div class="row">
          <div class="col">
            <p class="h3 dg-subheader">A few Examples</p>
            <div class="d-flex p-2 mb-3 bg-light">I'm a flexbox container!</div>
            <div class="d-inline-flex p-2 bg-light">I'm an inline flexbox container!</div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <p class="h3 dg-subheader">Code</p>
            <pre class="code-sample">
              <code class="html">
&lt;div class="d-flex"&gt; ... &lt;/div&gt;

&lt;div class="d-inline-flex"&gt; ... &lt;/div&gt;</code>
            </pre>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">

            <div class="row">
              <div class="col">
                <p class="h3 dg-subheader">Variants / Modifiers</p>   
              </div>
            </div>

            <div class="row">
              <div class="col">
                <p>Responsive variations also exist for <span class="code">.d-flex</span> and <span class="code">.d-inline-flex</span>.</p>
                <ul>
                  <li class="var-sample mb-2">.d-flex</li>
                  <li class="var-sample mb-2">.d-inline-flex</li>
                  <li class="var-sample mb-2">.d-sm-flex</li>
                  <li class="var-sample mb-2">.d-sm-inline-flex</li>
                  <li class="var-sample mb-2">.d-md-flex</li>
                  <li class="var-sample mb-2">.d-md-inline-flex</li>
                  <li class="var-sample mb-2">.d-lg-flex</li>
                  <li class="var-sample mb-2">.d-lg-inline-flex</li>
                  <li class="var-sample mb-2">.d-xl-flex</li>
                  <li class="var-sample mb-2">.d-xl-inline-flex</li>
                </ul>   
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p class="h4">Direction</p>
                <p>Set the direction of flex items in a flex container with direction utilities. In most cases you can omit the horizontal class here as the browser default is row.</p>
                <p>Use <span class="code">.flex-row</span> to set a horizontal direction (the browser default), or <span class="code">.flex-row-reverse</span> to start the horizontal direction from the opposite side.</p>
                <p>Use <span class="code">.flex-column</span> to set a vertical direction, or <span class="code">.flex-column-reverse</span> to start the vertical direction from the opposite side.</p>    
                <p>Responsive variations also exist for <span class="code">flex-direction</span>.</p>
                <ul>
                  <li class="var-sample mb-2">.flex-row</li>
                  <li class="var-sample mb-2">.flex-row-reverse</li>
                  <li class="var-sample mb-2">.flex-column</li>
                  <li class="var-sample mb-2">.flex-column-reverse</li>
                  <li class="var-sample mb-2">.flex-sm-row</li>
                  <li class="var-sample mb-2">.flex-sm-row-reverse</li>
                  <li class="var-sample mb-2">.flex-sm-column</li>
                  <li class="var-sample mb-2">.flex-sm-column-reverse</li>
                  <li class="var-sample mb-2">.flex-md-row</li>
                  <li class="var-sample mb-2">.flex-md-row-reverse</li>
                  <li class="var-sample mb-2">.flex-md-column</li>
                  <li class="var-sample mb-2">.flex-md-column-reverse</li>
                  <li class="var-sample mb-2">.flex-lg-row</li>
                  <li class="var-sample mb-2">.flex-lg-row-reverse</li>
                  <li class="var-sample mb-2">.flex-lg-column</li>
                  <li class="var-sample mb-2">.flex-lg-column-reverse</li>
                  <li class="var-sample mb-2">.flex-xl-row</li>
                  <li class="var-sample mb-2">.flex-xl-row-reverse</li>
                  <li class="var-sample mb-2">.flex-lg-column</li>
                  <li class="var-sample mb-2">.flex-lg-column-reverse</li>
                </ul>
              </div>
            </div>
            
            <div class="row mt-4">
              <div class="col">
                <p class="h4">Justify Content</p>
                <p>Use <span class="code">justify-content</span> utilities on flexbox containers to change the alignment of flex items on the main axis (the x-axis to start, y-axis if <span class="code">flex-direction: column</span>). Choose from <span class="code">start</span> (browser default), <span class="code">end</span>, <span class="code">center</span>, <span class="code">between</span>, or <span class="code">around</span>.</p>
                <p>Responsive variations also exist for <span class="code">justify-content</span>.</p>
                <ul>
                  <li class="var-sample mb-2">.justify-content-start</li>
                  <li class="var-sample mb-2">.justify-content-end</li>
                  <li class="var-sample mb-2">.justify-content-center</li>
                  <li class="var-sample mb-2">.justify-content-between</li>
                  <li class="var-sample mb-2">.justify-content-around</li>
                  <li class="var-sample mb-2">.justify-content-sm-start</li>
                  <li class="var-sample mb-2">.justify-content-sm-end</li>
                  <li class="var-sample mb-2">.justify-content-sm-center</li>
                  <li class="var-sample mb-2">.justify-content-sm-between</li>
                  <li class="var-sample mb-2">.justify-content-sm-around</li>
                  <li class="var-sample mb-2">.justify-content-md-start</li>
                  <li class="var-sample mb-2">.justify-content-md-end</li>
                  <li class="var-sample mb-2">.justify-content-md-center</li>
                  <li class="var-sample mb-2">.justify-content-md-between</li>
                  <li class="var-sample mb-2">.justify-content-md-around</li>
                  <li class="var-sample mb-2">.justify-content-lg-start</li>
                  <li class="var-sample mb-2">.justify-content-lg-end</li>
                  <li class="var-sample mb-2">.justify-content-lg-center</li>
                  <li class="var-sample mb-2">.justify-content-lg-between</li>
                  <li class="var-sample mb-2">.justify-content-lg-around</li>
                  <li class="var-sample mb-2">.justify-content-xl-start</li>
                  <li class="var-sample mb-2">.justify-content-xl-end</li>
                  <li class="var-sample mb-2">.justify-content-xl-center</li>
                  <li class="var-sample mb-2">.justify-content-xl-between</li>
                  <li class="var-sample mb-2">.justify-content-xl-around</li>
                </ul>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p class="h4">Align Items</p>
                <p>Use <span class="code"></span> utilities on flexbox containers to change the alignment of flex items on the cross axis (the y-axis to start, x-axis if <span class="code">flex-direction: column</span>). Choose from <span class="code">start</span>, <span class="code">end</span>, <span class="code">center</span>, <span class="code">baseline</span>, or <span class="code">stretch</span> (browser default).</p>
                <p>Responsive variations also exist for <span class="code">align-items</span>.</p>
                <ul>
                  <li class="var-sample mb-2">.align-items-start</li>
                  <li class="var-sample mb-2">.align-items-end</li>
                  <li class="var-sample mb-2">.align-items-center</li>
                  <li class="var-sample mb-2">.align-items-baseline</li>
                  <li class="var-sample mb-2">.align-items-stretch</li>
                  <li class="var-sample mb-2">.align-items-sm-start</li>
                  <li class="var-sample mb-2">.align-items-sm-end</li>
                  <li class="var-sample mb-2">.align-items-sm-center</li>
                  <li class="var-sample mb-2">.align-items-sm-baseline</li>
                  <li class="var-sample mb-2">.align-items-sm-stretch</li>
                  <li class="var-sample mb-2">.align-items-md-start</li>
                  <li class="var-sample mb-2">.align-items-md-end</li>
                  <li class="var-sample mb-2">.align-items-md-center</li>
                  <li class="var-sample mb-2">.align-items-md-baseline</li>
                  <li class="var-sample mb-2">.align-items-md-stretch</li>
                  <li class="var-sample mb-2">.align-items-lg-start</li>
                  <li class="var-sample mb-2">.align-items-lg-end</li>
                  <li class="var-sample mb-2">.align-items-lg-center</li>
                  <li class="var-sample mb-2">.align-items-lg-baseline</li>
                  <li class="var-sample mb-2">.align-items-lg-stretch</li>
                  <li class="var-sample mb-2">.align-items-xl-start</li>
                  <li class="var-sample mb-2">.align-items-xl-end</li>
                  <li class="var-sample mb-2">.align-items-xl-center</li>
                  <li class="var-sample mb-2">.align-items-xl-baseline</li>
                  <li class="var-sample mb-2">.align-items-xl-stretch</li>
                </ul>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p class="h4">Align Self</p>
                <p>Use <span class="code">align-self</span> utilities on flexbox items to individually change their alignment on the cross axis (the y-axis to start, x-axis if <span class="code">flex-direction: column</span>). Choose from the same options as <span class="code">align-items: start</span>, <span class="code">end</span>, <span class="code">center</span>, <span class="code">baseline</span>, or <span class="code">stretch</span> (browser default).</p>
                <p>Responsive variations also exist for span,<code>align-self</code>.</p>
                <ul>
                  <li class="var-sample mb-2">.align-self-start</li>
                  <li class="var-sample mb-2">.align-self-end</li>
                  <li class="var-sample mb-2">.align-self-center</li>
                  <li class="var-sample mb-2">.align-self-baseline</li>
                  <li class="var-sample mb-2">.align-self-stretch</li>
                  <li class="var-sample mb-2">.align-self-sm-start</li>
                  <li class="var-sample mb-2">.align-self-sm-end</li>
                  <li class="var-sample mb-2">.align-self-sm-center</li>
                  <li class="var-sample mb-2">.align-self-sm-baseline</li>
                  <li class="var-sample mb-2">.align-self-sm-stretch</li>
                  <li class="var-sample mb-2">.align-self-md-start</li>
                  <li class="var-sample mb-2">.align-self-md-end</li>
                  <li class="var-sample mb-2">.align-self-md-center</li>
                  <li class="var-sample mb-2">.align-self-md-baseline</li>
                  <li class="var-sample mb-2">.align-self-md-stretch</li>
                  <li class="var-sample mb-2">.align-self-lg-start</li>
                  <li class="var-sample mb-2">.align-self-lg-end</li>
                  <li class="var-sample mb-2">.align-self-lg-center</li>
                  <li class="var-sample mb-2">.align-self-lg-baseline</li>
                  <li class="var-sample mb-2">.align-self-lg-stretch</li>
                  <li class="var-sample mb-2">.align-self-xl-start</li>
                  <li class="var-sample mb-2">.align-self-xl-end</li>
                  <li class="var-sample mb-2">.align-self-xl-center</li>
                  <li class="var-sample mb-2">.align-self-xl-baseline</li>
                  <li class="var-sample mb-2">.align-self-xl-stretch</li>
                </ul>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p class="h4">Auto Margins</p>
                <p>Flexbox can do some pretty awesome things when you mix flex alignments with auto margins. Shown below are three examples of controlling flex items via auto margins: default (no auto margin), pushing two items to the right (<span class="code">.mr-auto</span>), and pushing two items to the left (<span class="code">.ml-auto</span>).</p>
                <p><b>Unfortunately, IE10 and IE11 do not properly support auto margins on flex items whose parent has a non-default <span class="code">justify-content</span> value.</b></p>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p class="h4">With align-items</p>
                <p>Vertically move one flex item to the top or bottom of a container by mixing <span class="code">align-items</span>, <span class="code">flex-direction: column</span>, and <span class="code">margin-top: auto</span> or <span class="code">margin-bottom: auto</span>.</p>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p class="h4">Wrap</p>
                <p>Change how flex items wrap in a flex container. Choose from no wrapping at all (the browser default) with <span class="code">.flex-nowrap</span>, wrapping with <span class="code">.flex-wrap</span>, or reverse wrapping with <span class="code">.flex-wrap-reverse</span>.</p>
                <p>Responsive variations also exist for <span class="code">flex-wrap</span>.</p>
                <ul>
                  <li class="var-sample mb-2">.flex-nowrap</li>
                  <li class="var-sample mb-2">.flex-wrap</li>
                  <li class="var-sample mb-2">.flex-wrap-reverse</li>
                  <li class="var-sample mb-2">.flex-sm-nowrap</li>
                  <li class="var-sample mb-2">.flex-sm-wrap</li>
                  <li class="var-sample mb-2">.flex-sm-wrap-reverse</li>
                  <li class="var-sample mb-2">.flex-md-nowrap</li>
                  <li class="var-sample mb-2">.flex-md-wrap</li>
                  <li class="var-sample mb-2">.flex-md-wrap-reverse</li>
                  <li class="var-sample mb-2">.flex-lg-nowrap</li>
                  <li class="var-sample mb-2">.flex-lg-wrap</li>
                  <li class="var-sample mb-2">.flex-lg-wrap-reverse</li>
                  <li class="var-sample mb-2">.flex-xl-nowrap</li>
                  <li class="var-sample mb-2">.flex-xl-wrap</li>
                  <li class="var-sample mb-2">.flex-xl-wrap-reverse</li>
                </ul>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p class="h4">Order</p>
                <p>Change the visual order of specific flex items with a handful of <span class="code">order</span> utilities. We only provide options for making an item first or last, as well as a reset to use the DOM order. As <span class="code">order</span> takes any integer value (e.g., <span class="code">5</span>), add custom CSS for any additional values needed.</p>
                <p>Responsive variations also exist for <span class="code">order</span>.</p>
                <ul>
                  <li class="var-sample mb-2">.order-{0 - 12}</li>
                  <li class="var-sample mb-2">.order-sm-{0 - 12}</li>
                  <li class="var-sample mb-2">.order-md-{0 - 12}</li>
                  <li class="var-sample mb-2">.order-lg-{0 - 12}</li>
                  <li class="var-sample mb-2">.order-xl-{0 - 12}</li>
                </ul>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p class="h4">Align Content</p>
                <p>Use <span class="code">align-content</span> utilities on flexbox containers to align flex items together on the cross axis. Choose from <span class="code">start</span> (browser default), <span class="code">end</span>, <span class="code">center</span>, <span class="code">between</span>, <span class="code">around</span>, or <span class="code">stretch</span>. To demonstrate these utilities, we’ve enforced <span class="code">flex-wrap: wrap</span> and increased the number of flex items.</p>
                <p>Responsive variations also exist for <span class="code">align-content</span>.</p>
                <ul>
                  <li class="var-sample mb-2">.align-content-start</li>
                  <li class="var-sample mb-2">.align-content-end</li>
                  <li class="var-sample mb-2">.align-content-center</li>
                  <li class="var-sample mb-2">.align-content-around</li>
                  <li class="var-sample mb-2">.align-content-stretch</li>
                  <li class="var-sample mb-2">.align-content-sm-start</li>
                  <li class="var-sample mb-2">.align-content-sm-end</li>
                  <li class="var-sample mb-2">.align-content-sm-center</li>
                  <li class="var-sample mb-2">.align-content-sm-around</li>
                  <li class="var-sample mb-2">.align-content-sm-stretch</li>
                  <li class="var-sample mb-2">.align-content-md-start</li>
                  <li class="var-sample mb-2">.align-content-md-end</li>
                  <li class="var-sample mb-2">.align-content-md-center</li>
                  <li class="var-sample mb-2">.align-content-md-around</li>
                  <li class="var-sample mb-2">.align-content-md-stretch</li>
                  <li class="var-sample mb-2">.align-content-lg-start</li>
                  <li class="var-sample mb-2">.align-content-lg-end</li>
                  <li class="var-sample mb-2">.align-content-lg-center</li>
                  <li class="var-sample mb-2">.align-content-lg-around</li>
                  <li class="var-sample mb-2">.align-content-lg-stretch</li>
                  <li class="var-sample mb-2">.align-content-xl-start</li>
                  <li class="var-sample mb-2">.align-content-xl-end</li>
                  <li class="var-sample mb-2">.align-content-xl-center</li>
                  <li class="var-sample mb-2">.align-content-xl-around</li>
                  <li class="var-sample mb-2">.align-content-xl-stretch</li>
                </ul>
              </div>
            </div>
            
            
          </div>
        </div>
       <!--  <div class="row mt-4">
          <div class="col">
            <p class="h4 dg-subheader">Accessibility</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi ad doloremque rem quasi voluptatum temporibus voluptates non unde, veritatis molestias velit impedit iste tenetur officiis et quae nisi facilis atque!</p>
          </div>
        </div> -->
        <!-- Content End -->
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "Flex"
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Flex.vue